export const StoresData = [
    {
        slug: "virsa",
        title: "Virsa",
        bgImage: "/images/virsa-store.png",
        phone_number: "9418760706",
        trading_hours: "10.00am - 7.00 pm",
        email_address: "virsashimla@gmail.com",
        description: "Virsa is a store known for its heritage Collection of women's clothing.",
        bannerImage: "/images/single-attrac-banner.png",
        longDesc: "In 2017, it was opened to the public at the Adventure Resort. It's a label that's owned and operated in the area, and it's known for its high-quality wool garments and fashionable options for ladies. This shop sells shawls, stoles, Lohis, mufflers, and other wool accessories from Himachal Pradesh, including Pashmina, yak, angora, and pure wool."
    },
    {
        slug: "himachali-handicraft",
        title: "Himachali Handicraft",
        bgImage: "/images/handloom-store.png",
        phone_number: "8988126453",
        trading_hours: "9:00 AM TO 6:00 PM",
        email_address: "kufrifuncampus@gmail.com",
        description: "High-quality wooden souvenirs are the store's speciality.",
        bannerImage: "/images/single-attrac-banner.png",
        longDesc: "As the name implies, Himachali Handicraft has a unique collection of wooden handicrafts and gifts from the Himachali region. Clocks, kitchenware, toys, wall art, and other home goods may all be found here. Shop is an absolute must-see for all sightseers in the area."
    },
    {
        slug: "drapplez-apple-chips",
        title: "Drapplez Apple Chips",
        bgImage: "/images/drapplez-store.png",
        phone_number: "8219379591",
        trading_hours: "9:30 AM TO 7:00 PM",
        email_address: "drapplez@acehealthybites.com",
        description: "First-ever launch of Dried Apple Chips in a variety of flavors.",
        bannerImage: "/images/single-attrac-banner.png",
        longDesc: "Since 2017, Drapplez has been a solitary first-time start-up of Dried Apple Chips in various flavors from Shimla, focusing on processing various dried food products. Therefore, we encourage you to stop by our sampling counter here at Adventure Resorts New Kufri."
    },
    {
        slug: "shimla-handloom-and-handicrafts",
        title: "Shimla Handloom & Handicrafts",
        bgImage: "/images/handloom-store.png",
        phone_number: "9882694640",
        trading_hours: "9:30 AM to 6:30 AM",
        email_address: "Karolshivam4@gmail.com",
        description: "This handloom and handicrafts store offers the finest quality woolen clothing and wooden handicrafts.",
        bannerImage: "/images/single-attrac-banner.png",
        longDesc: "Shimla Handloom & Handicrafts has been in business for eight years now at Adventure Resort. One may purchase a kullu patti, a Pashmina shawl, a woolen muffler, jackets, ponchu hats, or any number of other handloom items. They also sell wooden toys and arts & crafts, which are quite popular with children."
    },
    {
        slug: "photo-shop",
        title: "PHOTO SHOP",
        bgImage: "/images/store-img1.png",
        phone_number: "8219366203",
        trading_hours: "9:30 AM to 6:30 PM",
        email_address: "shubhammehta965@gmail.com",
        description: "A Himachali Traditional Dress Photo Shoot Studio that offers traditional jewelry and outfits for photographs.",
        bannerImage: "/images/single-attrac-banner.png",
        longDesc: "We are a Himachali Traditional Dress Photo Shoot Studio that has been operating inside Adventure Resort for the last 9 years. We have all of the traditional pahadi women's jewellery, such as Chakk (silver domed and worn on top of head), Chanderhar (necklace or pendant used at weddings), and so on."
    },
    {
        slug: "natures-nut",
        title: "Nature's Hut",
        bgImage: "/images/naturehuts-store.png",
        phone_number: "9872222244",
        trading_hours: "9:00 AM - 6:30 PM",
        email_address: "nectarfoods33@gmail.com",
        description: "This store sells healthy, organic foods items that are good for your overall well-being.",
        bannerImage: "/images/single-attrac-banner.png",
        longDesc: "This store sells organic food and cosmetics such as Fruit Barfi, Shilajit, Kesar, Herbal Tea, Herbal Cosmetic, Juices, Pickles, and so on. This outlet will give you the best food items for your wellness."
    },
]